import ActionType from "../../types/ActionType"
import OrganizationExternalInfosActions from "../actions/organizationExternalInfos"
import { OrganizationLegalInfo } from "../../types/OrganizationExternalInfoType"

export interface OrganizationExternalInfosStore {
  organizationExternalInfoErrorMessage: string
  loadingOrganizationExternalInfo: boolean
  legalInfo: OrganizationLegalInfo
}

const INITIAL_STATE: OrganizationExternalInfosStore = {
  organizationExternalInfoErrorMessage: "",
  loadingOrganizationExternalInfo: false,
  legalInfo: {
    name: "Nimble.LA",
    shortName: "nimbleLA",
    legalText: `
    <div>
<h2>What is Lorem Ipsum?</h2>
<p><strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
</div>
    `,
  },
}

export default (state = INITIAL_STATE, action: ActionType) => {
  switch (action.type) {
    case OrganizationExternalInfosActions.FETCH_ORGANIZATION_EXTERNAL_INFO_TRIGGER: {
      return {
        ...state,
        loadingOrganizationExternalInfo: true,
      }
    }

    case OrganizationExternalInfosActions.FETCH_ORGANIZATION_EXTERNAL_INFO_SUCCESS: {
      return {
        ...state,
        loadingOrganizationExternalInfo: false,
        legalInfo: action.payload,
      }
    }

    case OrganizationExternalInfosActions.FETCH_ORGANIZATION_EXTERNAL_INFO_ERROR: {
      return {
        ...state,
        loadingOrganizationExternalInfo: false,
        organizationExternalInfoErrorMessage: action.payload,
      }
    }

    default:
      return state
  }
}
